module.exports = __webpack_public_path__ + "static/img/pars5.f43f55e1.png";